import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Pagination, Spinner } from "@/components/ui"
import DetailTemplate from '@/components/DetailTemplate'

import { useBienContext } from "../BienContext"
import { fetchMandats, setFilters } from "../../mandats/mandatsSlice"
import { FORM_TYPES } from '../../mandats/MandatFormContext'
import Form from "../../mandats/Form"
import MandatItem from "./MandatItem"

export default () => {
  const dispatch = useDispatch()
  const { bien } = useBienContext()

  const mandats = useSelector(state => state.mandats.items)
  const pagination = useSelector(state => state.mandats.pagination)
  const filters = useSelector(state => state.mandats.filters)
  const isLoading = useSelector(state => state.mandats.loadingStatus.fetchList)

  useEffect(
    () => {
      dispatch(fetchMandats({bien_id: bien.id}))
    },
    [bien.id]
  )

  const [formType, setFormType] = useState(FORM_TYPES.NEW)

  const modalContent = () => <Form formType={formType} />

  useEffect(() => {
    if(filters.page != pagination.currentPage) {
      const queryFilters = { ...filters, bien_id: bien.id}
      dispatch(fetchMandats(queryFilters))
    }
  }, [dispatch, filters])

  const handlePageChange = (page) => {
    dispatch(setFilters({ page }))
  } 

  return (
    <DetailTemplate
      title="Historique des mandats"
      modalContent={modalContent()}
      bodyProps={{columns: 1}}
    >
      <table className="table">
        <thead>
          <tr className="text-left">
            <th>Propriétaires signataires</th>
            <th>Type de mandat</th>
            <th>N° mandat</th>
            <th>Date de signature</th>
            <th>Date de fin</th>
            <th>Exclusivité</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          { isLoading && <tr><td colSpan="7" className="p-2 text-center"><Spinner/></td></tr>}
          { !isLoading && mandats.length == 0 && <tr><td colSpan="7" className="p-2 text-center">Aucun mandat</td></tr>}
          { !isLoading && mandats.length > 0 && 
            mandats.map( (item, index) => <MandatItem item={item} key={index} changeFormType={setFormType} /> )
          }
        </tbody>
      </table>
      {pagination.totalPages > 1 && (
        <Pagination 
          currentPage={pagination.currentPage}
          totalPages={pagination.totalPages}
          onPageChange={handlePageChange}
        />
      )}
    </DetailTemplate>
  )
}